import React from 'react';
import TextBox from './TextBox';
import Button from './Button';
import RadioButtonGroup from './RadioButtonGroup';
import RadioButton from './RadioButton';
const { Fields } = require("../../backend/fields");
import { pickTextColorBasedOnBgColorSimple, getBrowserLanguage } from '../util';
import { translate, translateFields, translateFieldTemplate } from '../../backend/locale';
import { getCompanyFieldLabel } from '../../backend/companyConfig';
import { PAYMENT_METHOD_CARD, PAYMENT_METHOD_MOBILE, PAYMENT_METHOD_MAESTRO } from '../constants';

function getFaqUrl(faqUrls = {}) {  
  if (!faqUrls || (!faqUrls.en && !faqUrls.fr)) {
      return '';
  }
  
  const language = getBrowserLanguage().toLowerCase();
  const supportedLanguages = ['fr', 'en'];
  const defaultLanguage = 'en';
  
  const selectedLanguage = supportedLanguages.includes(language) 
      ? language 
      : defaultLanguage;
  
  const url = faqUrls[selectedLanguage] || faqUrls[defaultLanguage];
  return url;
}

export default function Form({
    primaryColor,
    departureDate,
    flightNumber,
    flightNumberPrefix,
    seatNumber,
    invoiceId,
    lastDigits,
    departureDateValid,
    flightNumberValid,
    seatNumberValid,
    invoiceIdValid,
    lastDigitsValid,
    onDepartureDateChange,
    onFlightNumberChange,
    onSeatNumberChange,
    onInvoiceIdChange,
    onLastDigitsChange,
    onDepartureDateBlur,
    onFlightNumberBlur,
    onSeatNumberBlur,
    onInvoiceIdBlur,
    onLastDigitsBlur,
    onPaymentMethodChange,
    selectedPaymentMethod,
    enablePaymentMethods,
    onSubmit,
    companyType,
    allFieldsValid,
    invoiceIdActive,
    companyCode,
    seatNumberActive,
    flightNumberMandatory,
    enableFaqMessage,
    faqUrls,
  }) {
    const icon = primaryColor && pickTextColorBasedOnBgColorSimple(primaryColor, '#ffffff', '#434343') === '#ffffff' ? 'aircraft.png' : 'aircraft-dark.png';
    const showAirplaneIcon = companyType === 'air';
    const textBoxes = [
      <TextBox
        key={1}
        text={departureDate}
        label={translate('search_departure_date', getBrowserLanguage())}
        type={'date'}
        valid={departureDateValid}
        onBlur={onDepartureDateBlur}
        placeholder={(new Date()).toLocaleDateString('en-GB')}
        mandatory={true}
        onChange={onDepartureDateChange}/>,
      <TextBox
        key={2}
        text={lastDigits}
        label={translate('search_last_4_digits', getBrowserLanguage())}
        placeholder={'4460'}
        mandatory={![PAYMENT_METHOD_MOBILE, PAYMENT_METHOD_MAESTRO].includes(selectedPaymentMethod)}
        valid={lastDigitsValid}
        onBlur={onLastDigitsBlur}
        onChange={onLastDigitsChange}
        type='number'/>,
      <TextBox
        key={3}
        mandatory={flightNumberMandatory || [PAYMENT_METHOD_MOBILE, PAYMENT_METHOD_MAESTRO].includes(selectedPaymentMethod)}
        text={flightNumber}
        label={translate(`search_journey_number_${companyType}`, getBrowserLanguage())}
        placeholder={'8412'}
        maxLength={showAirplaneIcon ? 4 : 6}
        valid={flightNumberValid}
        onBlur={onFlightNumberBlur}
        pretext={showAirplaneIcon && flightNumberPrefix}
        onChange={onFlightNumberChange}
        type={showAirplaneIcon ? 'number' : 'text'}/>,
    ];
    if ([PAYMENT_METHOD_MOBILE, PAYMENT_METHOD_MAESTRO].includes(selectedPaymentMethod)) {
      if (seatNumberActive) {
        textBoxes.push(
          <TextBox
            key={4}
            mandatory={true}
            text={seatNumber}
            label={translate('search_seat_number', getBrowserLanguage())}
            placeholder={'12A'}
            onBlur={onSeatNumberBlur}
            valid={seatNumberValid}
            maxLength={3}
            onEnter={onSubmit}
            onChange={onSeatNumberChange}/>
        );
      }
      if (invoiceIdActive) {
        textBoxes.push(
          <TextBox
            key={5}
            mandatory={true}
            text={invoiceId}
            label={translateFields(Fields.INVOICE_ID, getBrowserLanguage())}
            placeholder={'cc1722757642'}
            onBlur={onInvoiceIdBlur}
            valid={invoiceIdValid}
            maxLength={12}
            onEnter={onSubmit}
            onChange={onInvoiceIdChange}/>
        );
      }
      textBoxes.push(textBoxes.splice(1, 1)[0]);
    }
    return (
      <div>
        <div className='title'>{translate(`search_guide_${companyType}`, getBrowserLanguage())}</div>
          { enablePaymentMethods && <RadioButtonGroup title={translate('search_payment_method', getBrowserLanguage())}>
            <RadioButton
              // style={window.innerWidth > 480 ? {width: '37%'} : {}}
              style={window.innerWidth > 480 ? {width: '50%'} : {}}
              checked={selectedPaymentMethod === PAYMENT_METHOD_CARD}
              onChange={onPaymentMethodChange}
              id={PAYMENT_METHOD_CARD}
              label={translateFields(getCompanyFieldLabel(companyCode, 'cardLabel'), getBrowserLanguage())}
            />
            {/* <RadioButton
              style={window.innerWidth > 480 ? {width: '31%'} : {}}
              checked={selectedPaymentMethod === PAYMENT_METHOD_MOBILE}
              onChange={onPaymentMethodChange}
              id={PAYMENT_METHOD_MOBILE}
              label={translate(PAYMENT_METHOD_MOBILE, getBrowserLanguage())}
            /> */}
            <RadioButton
              // style={window.innerWidth > 480 ? {width: '31%'} : {}}
              style={window.innerWidth > 480 ? {width: '50%'} : {}}
              checked={selectedPaymentMethod === PAYMENT_METHOD_MAESTRO}
              onChange={onPaymentMethodChange}
              id={PAYMENT_METHOD_MAESTRO}
              label={translateFields(getCompanyFieldLabel(companyCode, 'maestroLabel'), getBrowserLanguage())}
            />
          </RadioButtonGroup>
          }
      { enableFaqMessage &&
        <div style={{ marginTop: '10px', marginBottom: '10px' }}
            dangerouslySetInnerHTML={{
                __html: translateFieldTemplate(Fields.MOBILE_PAYMENT_FAQ, [getFaqUrl(faqUrls)], getBrowserLanguage())
            }}
        />
      }
          {textBoxes}
          <div style={{ marginTop: 35, marginBottom: 25 }}>
            <Button
              disabled={!allFieldsValid}
              onClick={onSubmit}
              text={translate('btn_find_my_receipts', getBrowserLanguage())}
              icon={showAirplaneIcon && `/static/${icon}`}
            />
          </div>
      </div>
    );
  }